import script from "./FileManagerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FileManagerModal.vue?vue&type=script&setup=true&lang=js"

import "./FileManagerModal.vue?vue&type=style&index=0&id=caa3420c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caa3420c"]])

export default __exports__